module.exports = __webpack_public_path__ + "static/media/onions-landingpage-1.b9585dd7.jpg";